import React from 'react';

const Logo = ({ className }) => {
  // Временно используем React logo, замените на свой
  // Положите свои файлы в public/logo.svg или импортируйте
  return (
    <div className={`logo-container ${className || ''}`}>
      {/* Вариант 1: Если у вас один SVG с возможностью изменения цвета */}
      <img 
        src="/logo.svg" 
        alt="Logo" 
        className="app-logo"
      />
      
      {/* Вариант 2: Разные логотипы для светлой/темной темы */}
      {/* <img 
        src="/logo-light.svg" 
        alt="Logo" 
        className="app-logo logo-light-theme"
      />
      <img 
        src="/logo-dark.svg" 
        alt="Logo" 
        className="app-logo logo-dark-theme"
      /> */}
    </div>
  );
};

export default Logo;

